import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "input", "lockedIcon", "unlockedIcon"]

  connect() {
    const index_id = this.scope.element.dataset.indexId
    const model = this.scope.element.dataset.modelName
    const canvas = this.canvasTarget,
      ctx = canvas.getContext("2d")
    const input = this.inputTarget
    const hasErrors = this.element.dataset.hasErrors === "true"
    if (index_id != undefined) {
      const base64String = document.getElementById(
        `${model}_${model}_sketches_attributes_${index_id}_sketch`,
      ).value
      if (base64String != "") {
        const background = new Image()
        background.src = base64String
        background.onload = function () {
          const hRatio = canvas.width / background.width
          const vRatio = canvas.height / background.height
          const ratio = Math.min(hRatio, vRatio)
          const centerShift_x = (canvas.width - background.width * ratio) / 2
          const centerShift_y = (canvas.height - background.height * ratio) / 2
          ctx.clearRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(
            background,
            0,
            0,
            background.width,
            background.height,
            centerShift_x,
            centerShift_y,
            background.width * ratio,
            background.height * ratio,
          )
        }
      }
    }

    if (canvas) {
      canvas.height = canvas.offsetHeight
      canvas.width = canvas.offsetWidth
      this.signaturePad = new SignaturePad(canvas, {
        penColor: "rgb(66, 133, 244)",
      })
      this._forceIOSTouchEvents()

      this.signaturePad.addEventListener("endStroke", () => {
        input.value = this.signaturePad.toDataURL()
      })
    }

    if (hasErrors) {
      this.unlockCanvas()
    } else {
      this.lockCanvas()
    }
  }

  undo() {
    const data = this.signaturePad.toData()
    if (data.length > 0) {
      data.pop()
      this.signaturePad.clear()
      this.signaturePad.fromData(data)
      this.inputTarget.value = this.signaturePad.toDataURL()
    }
  }

  disconnect() {
    this.signaturePad.off()
  }

  _forceIOSTouchEvents() {
    const isIOS =
      /iPhone|iPad|iPod/.test(navigator.userAgent) ||
      (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
    if (isIOS && window.PointerEvent) {
      this.signaturePad.off()
      const origPointerEvent = window.PointerEvent
      window.PointerEvent = undefined
      this.signaturePad.on()
      window.PointerEvent = origPointerEvent
    }
  }

  lockCanvas() {
    if (this.signaturePad) {
      this.signaturePad.on()
      this._forceIOSTouchEvents()
    }
    this.unlockedIconTarget.classList.contains("hidden") &&
      this.unlockedIconTarget.classList.remove("hidden")
    !this.lockedIconTarget.classList.contains("hidden") &&
      this.lockedIconTarget.classList.add("hidden")
  }

  unlockCanvas() {
    this.signaturePad && this.signaturePad.off()
    this.lockedIconTarget.classList.contains("hidden") &&
      this.lockedIconTarget.classList.remove("hidden")
    !this.unlockedIconTarget.classList.contains("hidden") &&
      this.unlockedIconTarget.classList.add("hidden")
  }
}
